import {
    apiRequest,
    cpnsPeriodCreate,
} from "../../../../../services/adapters/kepegawaian/cpnsService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", cpnsPeriodCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository